'use strict';

angular.module('app').factory('authHttpResponseInterceptor', function ($q, $location, $rootScope) {
  function handlerError(error) {
    _.each(error, function (errorMessage, key) {
      if (key === 'nonFieldErrors' || key === 'isDraft' ||  key === '__all__') {
        $rootScope.showNotify(errorMessage);
      } else if (_.isPlainObject(errorMessage)) {
        handlerError(errorMessage);
      } else if (key) {
        $rootScope.showNotify(key.replace(/([a-z])([A-Z])/g, '$1 $2') + ' - ' + errorMessage);
      }
    });
  }

  return {
    request: function (config) {
      if (localStorage.getItem('token') && config.url.indexOf('/api/v2/') !== -1) {
        config.headers.Authorization = 'JWT ' + localStorage.getItem('token');
      }

      return config;
    },
    response: function (response) {
      if (response.status === 401) {
        console.debug('Response 401');
      }

      return response || $q.when(response);
    },
    responseError: function (rejection) {
      if (rejection.status === 401) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('login_date');
        $location.path('/login/');
        $rootScope.user = null;
      }

      if (rejection.status === 400) {
        handlerError(rejection.data);
      }

      if (rejection.status === 500) {
        $rootScope.showNotify('Something went wrong!');
      }

      if (rejection.status === 502) {
        $rootScope.showNotify('Server is not available. Please try one more time!');
      }

      return $q.reject(rejection);
    },
  };
});
